import React from 'react';
import { Layout } from 'antd';
import './TicketTrafficManagement.css'; 
import MainLayout from "../../layout/mainlayout.tsx";
import TicketsByCategory from '../../components/chart_components/TicketsByCategory/TicketsByCategory.tsx'
import TicketCreationByDays from '../../components/chart_components/TicketCreationByDays/TicketCreationByDays.tsx';
import TicketsByStatus from '../../components/chart_components/TicketsByStatusPercentage/TicketsByStatusPercentage.tsx';
import AvgTicketClosure from '../../components/chart_components/AvgTicketClosure/AvgTicketClosure.tsx';
import CurrentTicketStatus from '../../components/chart_components/CurrentTicketStatus/CurrentTicketStatus.tsx';
import SummaryBoxes from '../../components/chart_components/SummaryBoxes/SummaryBoxes.tsx';

const { Content } = Layout;
const TicketTrafficManagement: React.FC = () => {
  return (
    <MainLayout>
      <Layout>
        <Content style={{ padding: '20px' }}>
          <h2>Ticket Traffic Management</h2>
          {/* Top Summary Boxes */}
          <SummaryBoxes/>
          <div className="chart-grid">
            {/* Ticket Creation by Days of the Week  */}
            <TicketCreationByDays/>
            {/* Tickets by Category in Percentage */}
            <TicketsByCategory />
            {/* Tickets by Status in Percentage */}
            <TicketsByStatus/>
            {/* Average Ticket Closure Time for Each Group */}
            <AvgTicketClosure/>
            {/* Current Tickets Status */}
            <CurrentTicketStatus/>
          </div>
        </Content>
      </Layout>
    </MainLayout>
  );
};

export default TicketTrafficManagement;
